export default __webpack_public_path__ + "static/A7-d7eb92faaefe3a1536a74725a0eae834.png";